import {Checkbox ,Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, FormControlLabel, FormControl, Stack, Snackbar } from "@mui/material";
import MuiAlert from '@mui/material/Alert';
import { useState } from 'react'
import { DatePicker, } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import enAU from 'date-fns/locale/en-AU';
import { Project } from "../../features/db/project";

export default function NewProjectDialog(props)
{
	const {variant} = props;
	const {submitCallback} = props;
	const [open, setOpen] = useState(false);

	const handleClick = ()=>{
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const [name, setName] = useState("");
	const handleNameChange = (e)=>
	{
		setName(e.target.value);
	}

	const [status, setStatus] = useState(true);
	const handleStatusChange = ()=>{
		setStatus(!status);
	}

	const [date, setDate] = useState("")
	const [dateRender, setDateRender] = useState(null)
	const onDateChange = e => {
		let newDate = e
		setDateRender(newDate);
		let stringDate = newDate.getFullYear();
		setDate(stringDate);
	};

	const [errorReason,setErrorReason] = useState("");
	const [openErrorSnack, setOpenErrorSnack] = useState(false);
	const handleErrorSnackClose = ()=>
	{
		setErrorReason("");
		setOpenErrorSnack(false);
	}

	const makeError = (reason)=>{
		setErrorReason(reason);
		setOpenErrorSnack(true);
	}

	const handleSubmit=()=>
	{
		if(name==="")
		{
			makeError("NO PROJECT ENTERED!");
			return;
		}
		if(name.includes("/"))
		{
			makeError("NAME CANNOT CONTAIN / !");
			return;
		}
		if(date==="")
		{
			makeError("NO DATE ENTERED!");
			return;
		}
		const p = new Project(name,date,status);
		p.submitAsNewProject().then(submitCallback(p));
		handleClose();
	}

	return (
		<>
		<Button onClick={handleClick} variant={variant}>New Project</Button>
		<Snackbar open={openErrorSnack} autoHideDuration={5000} onClose={handleErrorSnackClose} anchorOrigin={{ vertical:"top", horizontal:"center" }}>
				<MuiAlert variant="filled" severity="error">
					{errorReason}
				</MuiAlert>
		</Snackbar>
		<Dialog onClose={handleClose} open={open}>
			<DialogTitle>Create A New Project</DialogTitle>
			<DialogContent>
				<LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enAU}>
					<FormControl>
						<Stack spacing={{ xs: 1, sm: 2, md: 4 }}>
						<TextField
							autoFocus
							margin="dense"
							label="Project Name"
							fullWidth
							variant="outlined"
							onChange={handleNameChange}
						/>
						<DatePicker
							views={['year']}
							label="Project Year"
							value={dateRender}
							onChange={onDateChange}
							renderInput={(params) => <TextField {...params} helperText={null} />}
						/>
						<FormControlLabel
							control={<Checkbox checked={status} />} 
							label="Status [Active / Inactive]"
							labelPlacement="end"
							onChange={handleStatusChange}
						/>
						</Stack>
					</FormControl>
				</LocalizationProvider>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>Cancel</Button>
				<Button onClick={handleSubmit} variant='contained'>Submit</Button>
			</DialogActions>
		</Dialog>
		</>
	);
}